import Countries from '@/resources/countries.json';

export default class GetCountries {
    /**
     * Retrieve list of countries.
     *
     * @returns {Array}
     */
    handle() {
        return Countries;
    }
}
